import { FieldLabel, Select, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function AssertInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  const kind = c.kind || 'rowcount';
  return (
    <div>
      <FieldLabel>Assertion type</FieldLabel>
      <Select value={kind} onChange={(v) => u({ kind: v })}
        options={[
          { value: 'rowcount', label: 'Row count between min and max' },
          { value: 'unique', label: 'Column values are unique' },
          { value: 'not_null', label: 'Column has no nulls' },
          { value: 'sum', label: 'Sum of column equals total' },
        ]} />
      {kind === 'rowcount' && (
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={{ flex: 1 }}>
            <FieldLabel>Min rows (inclusive)</FieldLabel>
            <TextInput mono value={c.min ?? ''} onChange={(v) => u({ min: v })} placeholder="−∞" />
          </div>
          <div style={{ flex: 1 }}>
            <FieldLabel>Max rows (inclusive)</FieldLabel>
            <TextInput mono value={c.max ?? ''} onChange={(v) => u({ max: v })} placeholder="+∞" />
          </div>
        </div>
      )}
      {(kind === 'unique' || kind === 'not_null' || kind === 'sum') && (
        <>
          <FieldLabel>Column</FieldLabel>
          <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
        </>
      )}
      {kind === 'sum' && (
        <>
          <FieldLabel>Expected total</FieldLabel>
          <TextInput mono value={c.total ?? ''} onChange={(v) => u({ total: v })} placeholder="e.g. 100000" />
        </>
      )}
      <FieldLabel>Note (shown in run log)</FieldLabel>
      <TextInput value={c.note} onChange={(v) => u({ note: v })} placeholder="e.g. weekly export should never exceed 100k rows" />
      <FieldLabel>On failure</FieldLabel>
      <Segmented
        value={c.severity || 'halt'}
        onChange={(v) => u({ severity: v })}
        options={[
          { value: 'log', label: 'Log warning' },
          { value: 'halt', label: 'Halt run' },
        ]}
      />
    </div>
  );
}
